"use client";

import React from "react";
import { PrismicLink } from "@prismicio/react";
import { isFilled } from "@prismicio/client";

export default function CFooter({ layout }) {
  return (
    <footer className="w-full flex flex-col md:flex-row bg-white items-center z-120 md:fixed bottom-0 py-5 md:py-2.5 px-4 md:px-10 text-footer">
      {Array.isArray(layout.data.cta) && layout.data.cta.length > 0 && (
        <div className="flex gap-2.5">
          {layout.data.cta.map((link, index) => (
            <div key={index} className="flex items-center gap-2.5">
              <PrismicLink key={index} field={link}>
              </PrismicLink>
              <div className="hidden md:block w-4 h-[0.2px] bg-light-gray"></div>
            </div>
          ))}
        </div>
      )}
      <div className="hidden md:block flex-1 h-[0.2px] bg-light-gray"></div>
      {isFilled.keyText(layout.data.credit) && (
        <p className="ml-2.5">{layout.data.credit}</p>
      )}
    </footer>
  );
}
